import ActionTypes, {TagActionTypes} from "../constants/action_types";

export type ClearIssueOverrideTagsAction = {
  type: TagActionTypes["ISSUE_OVERRIDE_TAGS_CLEAR"]["SUCCESS"];
};

export default function clearIssueOverrideTags() {
  return {
    type: ActionTypes.ISSUE_OVERRIDE_TAGS_CLEAR.SUCCESS,
  };
}
